import { HttpClient } from '../HttpClient';
/**
 * * Post Company Employee List
 */
export const PostEmployeeList = async (EmployeeListParams) => {
  try {
    const { data } = await HttpClient.post(`/api/employees/SearchCriteria`, { ...EmployeeListParams });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
